import { Injectable } from '@angular/core';
import { AlertComponent } from '../structure/alert/alert.component';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private instance: AlertComponent | null = null;

  register(instance: AlertComponent) {
    console.log("✅ AlertComponent registered");
    this.instance = instance;
  }

  notify(message: string, callback?: () => void, callback1?:() => void) {
    console.log("📣 AlertService.notify called");
    this.instance?.notifyMeeting(message, callback,callback1);
  }
}